import React, { useEffect, useMemo, useState } from "react";
import { hasPermission } from "../../../helpers/utils/AccessControlUtils";
import { skipToken } from "@reduxjs/toolkit/query";
import PricingTableHead from "../../../components/common/PricingTableHead";
import { useGetAllTenantsQuery } from "../../customer/tenantApi";
import NumberFormat from "react-number-format";
import Pagination from "../../../components/common/pagination/Pagination";
import {
    useGetAllFulfillmentCustomerByTenantQuery,
} from "../../customer/customerApi";
import ConfirmationModal from "../../../components/layout/modal/ConfirmationModal";
import { showToast } from "../../../helpers/utils/Utils";
import { useCreateFulfillmentPricingMutation, useDeleteFulfillmentPricingByIdMutation, useLazyExportFulfillmentPricingDataQuery, useLazySearchFulFillmentPricingQuery, useSearchFulFillmentPricingQuery } from "./fulFillmentPricingApi";
import Preloader from "../../../components/common/Preloader";
import ModalButton from "../../../components/common/form/ModalButton";
import IconButton from "../../../components/common/form/IconButton";
import { FaTrash, FaUndo } from "react-icons/fa";
import { FaFileExport } from "react-icons/fa6";
import { useUtilDataQuery } from "../../profile/profileApi";

const FulFillmentPricing = () => {

    useEffect(() => {
        document.title = "FulFillment Pricing";
    });
    const { data: utilData } = useUtilDataQuery("");
    const [pricingQuery, setPricingQuery] = useState({});
    const defaultPageSize = useMemo(() => 15, []);
    const [fulfillmentPricingsQueryApi, fulfillmentPricingsQuery] = useLazySearchFulFillmentPricingQuery(pricingQuery || skipToken);
    const [description, setDescription] = useState("");
    const [id, setId] = useState(null);
    const [pageNumber, setPageNumber] = useState(0);
    const [sortOrder, setSortOrder] = useState("ASCENDING");
    const [sort, setSort] = useState("creationDate");
    const [tenant, setTenant] = useState(utilData?.customerLevel === 'SYS' ? "" : utilData?.tenant);
    const [customer, setCustomer] = useState("");
    const [pageSize, setPageSize] = useState(defaultPageSize);
    const [descriptionAlert, setDescriptionAlert] = useState(false);
    const [alert, setAlert] = useState("");
    const [isApplySearch, setIsApplySearch] = useState(false);
    const [showEditIcon, setShowEditIcon] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [discount, setDiscount] = useState("");
    const [discountPerParcel, setDiscountPerParcel] = useState("");
    const [fulfillmentFee, setFulfillmentFee] = useState("");
    const [fulfillmentFeePerParcel, setFulfillmentFeePerParcel] = useState("");
    const tenantsQueryApi = useGetAllTenantsQuery("");
    const customerTenantResponseApi = useGetAllFulfillmentCustomerByTenantQuery(tenant || skipToken);
    const [deleteFulFillmentPricing, { isLoading }] = useDeleteFulfillmentPricingByIdMutation();
    const [submitfulfillmentPricing] = useCreateFulfillmentPricingMutation();
    const [isExport, setIsExport] = useState(false);
    const [exportFulFillmentPricingApi] = useLazyExportFulfillmentPricingDataQuery();

    function showEditRow(obj: any) {
        setPageNumber(0);
        setId(obj.id);
        setDescription(obj.description);
        setTenant(obj.tenant);
        setCustomer(obj.customerId);
        setDiscount(obj.discount);
        setDiscountPerParcel(obj.discountPerParcel);
        setFulfillmentFee(obj.fulfillmentFee);
        setFulfillmentFeePerParcel(obj.fulfillmentFeePerParcel);
    }

    useEffect(() => {
        if (isApplySearch) {
            let query = getQuery();
            fulfillmentPricingsQueryApi(query)
            setIsApplySearch(false);
        }
    }, [isApplySearch]);

    useEffect(() => {
        if (sort) {
            let query = getQuery();
            fulfillmentPricingsQueryApi(query);
            setIsApplySearch(false);
        }
    }, [sort, sortOrder]);

    function getQuery() {
        return {
            pageNumber: pageNumber,
            pageSize: pageSize,
            sort: sort,
            sortOrder: sortOrder,
            tenant: tenant,
            customerId: customer
        }
    }
    const [thead] = useState(
        utilData?.customerLevel !== null && utilData?.customerLevel === 'SYS' ?
            [
                { content: "Description", sortColumn: "description" },
                { content: "Tenant", sortColumn: "tenant" },
                { content: "Customer", sortColumn: "customerName" },
                { content: "Discount", sortColumn: "displayPrice" },
                { content: "Discount Per Parcel", sortColumn: "displayPricePerParcel" },
                { content: "Fulfillment Fee", sortColumn: "price" },
                { content: "Fulfillment Fee Per Parcel", sortColumn: "pricePerParcel" },
                { content: hasPermission(["FFPRC-D"]) ? "Action" : "", sortColumn: "" }
            ]
            :

            [
                { content: "Description", sortColumn: "description" },
                { content: "Customer", sortColumn: "customerName" },
                { content: "Discount", sortColumn: "displayPrice" },
                { content: "Discount Per Parcel", sortColumn: "displayPricePerParcel" },
                { content: "Fulfillment Fee", sortColumn: "price" },
                { content: "Fulfillment Fee Per Parcel", sortColumn: "pricePerParcel" },
                { content: hasPermission(["FFPRC-D"]) ? "Action" : "", sortColumn: "" }
            ]
    )
    const input = {
        id: id,
        description: description,
        customerId: customer === '' ? null : customer,
        tenant: tenant === '' ? null : tenant,
        discount: discount === '' ? 0.0 : discount,
        discountPerParcel: discountPerParcel === '' ? 0.0 : discountPerParcel,
        fulfillmentFee: fulfillmentFee === '' ? 0.0 : fulfillmentFee,
        fulfillmentFeePerParcel: fulfillmentFeePerParcel === '' ? 0.0 : fulfillmentFeePerParcel,
    }

    function handleSubmit(e: any) {
        e.preventDefault();
        if (input.tenant === '' || input.tenant === null) {
            showToast("Tenant is required!");
            setAlert("tenant");
        } else if (input.customerId === '' || input.customerId === null) {
            setAlert("customer");
            return showToast("Customer is required!");
        } else if (input.discount === '' || input.discount === null) {
            setAlert("discount");
            return showToast("Discount is required!");
        } else if (input.discountPerParcel === '' || input.discountPerParcel === null) {
            setAlert("discountPerParcel");
            return showToast("Discount Per Parcel is required!");
        } else if (input.fulfillmentFee === '' || input.fulfillmentFee === null) {
            setAlert("fulfillmentFee");
            return showToast("Fulfillment Fee is required!");
        } else if (input.fulfillmentFeePerParcel === '' || input.fulfillmentFeePerParcel === null) {
            setAlert("fulfillmentFeePerParcel");
            return showToast("Fulfillment Fee Per Parcel is required!");
        } else {
            setAlert("");
            setIsSubmit(true);
        }
    }


    const handleDelete = async (fulFillmentId: any) => {
        if (fulFillmentId) {
            await deleteFulFillmentPricing(fulFillmentId).unwrap();
        }
    };

    useEffect(() => {
        if (pageNumber >= 0) {
            setPricingQuery({ pageNumber: pageNumber })
        }
    }, [pageNumber]);

    useEffect(() => {
        if (pageSize) {
            setPricingQuery({ pageNumber: pageNumber, pageSize: pageSize })
        }
    }, [pageSize]);

    function resetInput(reload = false) {
        setId(null);
        setDescription("");
        setTenant(utilData?.customerLevel === 'SYS' ? "" : utilData?.tenant);
        setCustomer("");
        setDiscount("")
        setDiscountPerParcel("");
        setFulfillmentFee("");
        setFulfillmentFeePerParcel("");
        fulfillmentPricingsQueryApi(pricingQuery)

    }

    const exportFulfillmentPricing = async () => {
        const query = getQuery();
        await exportFulFillmentPricingApi(query);
        setIsExport(false);
    };
    useEffect(() => {
        if (pricingQuery) {
            fulfillmentPricingsQueryApi(pricingQuery);
        }
    }, [pricingQuery]);

    useEffect(() => {
        if (isSubmit) {
            submitfulfillmentPricing(input);
            setIsSubmit(false);
            setShowEditIcon(false);
            resetInput();
        }

    }, [isSubmit]);

    return (
        <>
            {fulfillmentPricingsQuery.data === undefined
                ? <Preloader />
                :
                <>
                    <div className="gap-1 text-text-0 flex justify-end absolute right-[10px] top-0">
                        {hasPermission(["FFPRC-R"]) &&

                            <IconButton icon={<FaFileExport />}
                                hasBackground={true}
                                title={"Export Pricing"}
                                onClick={(e: any) => {
                                    if (!isExport) {
                                        e.preventDefault();
                                        setIsExport(true);
                                        exportFulfillmentPricing();
                                    }
                                }}
                                className={`px-3 py-2 rounded-xl ${isExport ? "bg-surface-4 export" : " export"}`}
                            />
                        }
                        <IconButton icon={<FaUndo size={14} />}
                            hasBackground={true}
                            title={"Reset Filter"}
                            onClick={() => {
                                setShowEditIcon(false);
                                resetInput(true);
                            }}
                            className={'px-3 py-2 rounded-xl '}
                        />
                    </div>
                    <div className={'overflow-auto'}>
                        <table className="p-3 w-full">

                            {!fulfillmentPricingsQuery.data && <thead>
                                <tr>
                                    {thead?.map((header) => {
                                        return (
                                            <th scope="col" className={'bg-highlight-0 text-text-0'}><a
                                                className="toggle-data-header toggle-data cursor">{header.content}<i
                                                    className="fas fa-sort" /></a></th>
                                        )
                                    })
                                    }
                                </tr>
                            </thead>
                            }

                            {fulfillmentPricingsQuery.data && <PricingTableHead headers={thead} data={fulfillmentPricingsQuery.data}
                                setSort={setSort}
                                sortOrder={sortOrder} setSortOrder={setSortOrder}
                            />}

                            <tbody>

                                {hasPermission(["FFPRC-C"]) &&

                                    <tr className={"bg-surface-7"}>
                                        <td>
                                            <textarea
                                                className={descriptionAlert ? " border border-surface-5 form-control table_data1" : "form-control  border border-surface-5"}
                                                placeholder="Enter Description..."
                                                value={description}
                                                onChange={(e) => {
                                                    setDescription(e.target.value);
                                                    setDescriptionAlert(false);
                                                }
                                                }
                                            />
                                        </td>
                                        {utilData?.customerLevel === 'SYS' && (


                                            <td>
                                                <div className="form-group">
                                                    <select
                                                        className={alert === "tenant" ? " border border-surface-5 form-control" : "form-control  border border-surface-5"}
                                                        required value={tenant}
                                                        onChange={(e) => {
                                                            setTenant(e.target.value)
                                                            setCustomer('')
                                                            setIsApplySearch(true);
                                                        }}
                                                    >
                                                        <option value="">Any</option>
                                                        {tenantsQueryApi.data && tenantsQueryApi.data.map((curTenant: any) => {
                                                            return (
                                                                <>
                                                                    <option value={curTenant.name}>{curTenant.name}</option>
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </td>
                                        )

                                        }

                                        {tenant === '' ?
                                            <td>
                                                <div className="form-group">
                                                    <select
                                                        className={alert === "customer" ? " border border-surface-5 form-control" : "form-control  border border-surface-5"}
                                                        value={customer}
                                                        onChange={(e) => {
                                                            setCustomer(e.target.value)
                                                            setIsApplySearch(true);
                                                        }}
                                                    >
                                                        <option value="">Any</option>
                                                    </select>
                                                </div>
                                            </td>
                                            :
                                            <td>
                                                <div className="form-group">
                                                    <select
                                                        className={alert === "customer" ? " border border-surface-5 form-control" : "form-control  border border-surface-5"}
                                                        value={customer}
                                                        onChange={(e) => {
                                                            setCustomer(e.target.value)
                                                            setIsApplySearch(true);

                                                        }}>
                                                        <option value="">Any</option>
                                                        {customerTenantResponseApi?.data && customerTenantResponseApi?.data?.map((curCustomer: any) => {
                                                            return (
                                                                <>
                                                                    <option
                                                                        value={curCustomer.id}>{curCustomer.customerName}</option>
                                                                </>
                                                            )
                                                        })}
                                                    </select>
                                                </div>
                                            </td>

                                        }

                                        <td>
                                            <NumberFormat placeholder='0.00'
                                                className={alert === "discount" ? " form-control text-center  border border-surface-5" : "form-control  border border-surface-5 text-center"}
                                                decimalScale={2}
                                                decimalSeparator="."
                                                fixedDecimalScale
                                                prefix={"$"}
                                                thousandSeparator={true}
                                                value={discount}
                                                onChange={(e: any) => {
                                                    setDiscount(e.target.value.replace('$', '').replaceAll(',', ''))
                                                }}
                                            />
                                        </td>
                                        <td>

                                            <NumberFormat placeholder='0.00'
                                                className={alert === "discountPerParcel" ? " border border-surface-5 form-control text-center alertClass" : " border border-surface-5 form-control text-center"}
                                                decimalScale={2}
                                                decimalSeparator="."
                                                fixedDecimalScale
                                                prefix={"$"}
                                                thousandSeparator={true}
                                                value={discountPerParcel}
                                                onChange={(e: any) => {
                                                    setDiscountPerParcel(e.target.value.replace('$', '').replaceAll(',', ''))
                                                }}
                                            />
                                        </td>
                                        <td>

                                            <NumberFormat placeholder='0.00'
                                                className={alert === "fulfillmentFee" ? " border border-surface-5 form-control text-center alertClass" : " border border-surface-5 form-control text-center"}
                                                decimalScale={2}
                                                decimalSeparator="."
                                                fixedDecimalScale
                                                prefix={"$"}
                                                thousandSeparator={true}
                                                value={fulfillmentFee}
                                                onChange={(e: any) => {
                                                    setFulfillmentFee(e.target.value.replace('$', '').replaceAll(',', ''))
                                                }}
                                            />

                                        </td>
                                        <td>

                                            <NumberFormat placeholder='0.00'
                                                className={alert === "fulfillmentFeePerParcel" ? " border border-surface-5 form-control text-center alertClass" : " border border-surface-5 form-control text-center"}
                                                decimalScale={2}
                                                decimalSeparator="."
                                                fixedDecimalScale
                                                prefix={"$"}
                                                thousandSeparator={true}
                                                value={fulfillmentFeePerParcel}
                                                onChange={(e: any) => {
                                                    setFulfillmentFeePerParcel(e.target.value.replace('$', '').replaceAll(',', ''))
                                                }}
                                            />

                                        </td>
                                        <td>
                                            <i className={!showEditIcon ? 'fa ml-3 mt-2 element icon fa-plus-circle cursor_hover text-highlight-0'  : 'fa ml-3 mt-2 element icon fa-edit cursor_hover text-highlight-0'}
                                                title="Add Price ..." onClick={handleSubmit} /> 
                                        </td>

                                    </tr>

                                }


                                {fulfillmentPricingsQuery.data && fulfillmentPricingsQuery.data.data && fulfillmentPricingsQuery.data.data.length === 0 &&
                                    <tr>
                                        <td colSpan={8}>There are No fulfillment pricing to display</td>
                                    </tr>

                                }

                                {fulfillmentPricingsQuery.data && fulfillmentPricingsQuery.data.error === undefined ? fulfillmentPricingsQuery.data.data && fulfillmentPricingsQuery.data.data.map((curPricing: any, index: number) => {
                                    return (
                                        <tr key={index} className={"odd:bg-surface-7 hover:bg-surface-7"}>
                                            <td>

                                                {hasPermission(["FFPRC-U"]) ?
                                                    <a className="text-highlight-4 active cursor-pointer" onClick={(e) => {
                                                        setShowEditIcon(true);
                                                        showEditRow(curPricing);
                                                        setIsApplySearch(true);
                                                    }}>{curPricing.description}</a> : <>{curPricing.description}</>}

                                            </td>

                                            {utilData?.customerLevel === 'SYS' ?
                                                <td>
                                                    {curPricing.tenant !== null && curPricing.tenant !== '' ? curPricing.tenant : 'Any'}

                                                </td>
                                                :
                                                ''
                                            }
                                            <td>{curPricing.customerName !== null && curPricing.customerName !== '' ? curPricing.customerName : 'Any'}</td>

                                            <td>
                                                <NumberFormat placeholder='0.00'
                                                    className="border-0 form-control text-center"
                                                    decimalScale={2}
                                                    decimalSeparator="."
                                                    fixedDecimalScale
                                                    prefix={"$"}
                                                    thousandSeparator={true}
                                                    value={curPricing.discount}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                <NumberFormat placeholder='0.00'
                                                    className="border-0 form-control text-center"
                                                    decimalScale={2}
                                                    decimalSeparator="."
                                                    fixedDecimalScale
                                                    prefix={"$"}
                                                    thousandSeparator={true}
                                                    value={curPricing.discountPerParcel}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                <NumberFormat placeholder='0.00'
                                                    className="border-0 form-control text-center"
                                                    decimalScale={2}
                                                    decimalSeparator="."
                                                    fixedDecimalScale
                                                    prefix={"$"}
                                                    thousandSeparator={true}
                                                    value={curPricing.fulfillmentFee}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                <NumberFormat placeholder='0.00'
                                                    className="border-0 form-control text-center"
                                                    decimalScale={2}
                                                    decimalSeparator="."
                                                    fixedDecimalScale
                                                    prefix={"$"}
                                                    thousandSeparator={true}
                                                    value={curPricing.fulfillmentFeePerParcel}
                                                    disabled={true}
                                                />
                                            </td>
                                            <td>
                                                {
                                                    hasPermission(["FFPRC-D"]) &&

                                                    <ModalButton
                                                        triggerButton={
                                                            <IconButton
                                                                icon={<FaTrash />}
                                                                title={"Delete Fulfillment Pricing"}
                                                                hasBackground={false}
                                                                className="mr-2 text-highlight-0"
                                                            />
                                                        }
                                                        modal={
                                                            <ConfirmationModal
                                                                show={true}
                                                                setShow={() => {
                                                                }}
                                                                title={"Delete Fulfillment Pricing"}
                                                                bodyMessage={"Are you sure you want to delete this Fulfillment Pricing?"}
                                                                onSubmit={() => handleDelete(curPricing.id)}
                                                                isLoading={isLoading}
                                                            />
                                                        }
                                                    />
                                                }
                                            </td>

                                        </tr>
                                    )
                                })
                                    :
                                    "no data found"
                                }
                            </tbody>
                        </table>
                    </div>
                    {
                        (fulfillmentPricingsQuery.data && fulfillmentPricingsQuery.data.totalPages != null && fulfillmentPricingsQuery.data.totalPages > 0) ?
                            <Pagination
                                displayText={fulfillmentPricingsQuery.data && fulfillmentPricingsQuery.data.displayingText}
                                pageCount={fulfillmentPricingsQuery.data && fulfillmentPricingsQuery.data.totalPages}
                                setPageNumber={setPageNumber}
                                pageNumber={pageNumber}
                                groupName="Fulfillment-Pricing"
                                setExternalPageSize={setPageSize}
                                permissions={"-"}
                            />
                            : ''
                    }
                </>
            }
        </>
    )
}
export default FulFillmentPricing;